import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { QuestionAnswerOutlined } from '@mui/icons-material';
import { useTranslation } from '../../hooks/useTranslation';
import BaseSidebar, { Item } from './BaseSidebar';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';

const SidebarUser = () => {
  const { t } = useTranslation();

  return (
    <BaseSidebar includeHeight={true}>
      {({ selected, setSelected, selectedSubmenu, setSelectedSubmenu }) => (
        <>
          <Item
            title={t('sidebar.dashboard')}
            to="/app/dashboard"
            icon={<HomeOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.proposals')}
            to="/app/proposals"
            icon={<AccountBalanceWalletOutlinedIcon />}
            selected={selected}
            setSelected={setSelected}
            setSelectedSubmenu={setSelectedSubmenu}
          />

          <Item
            title={t('sidebar.faq')}
            to="/app/help"
            icon={<QuestionAnswerOutlined />}
            selected={selected}
            setSelected={setSelected}
            setSelectedSubmenu={setSelectedSubmenu}
          />
        </>
      )}
    </BaseSidebar>
  );
};

export default SidebarUser;
